import { initSection as _initSection } from './main.js';
export const initSection = (selectors, init, { deferred =true  } = {})=>{
    if (deferred === false) {
        return _initSection(selectors, init);
    }
    let cleanup = null;
    const timeout = setTimeout(()=>{
        cleanup = _initSection(selectors, init);
    }, 0);
    return ()=>{
        if (cleanup != null) {
            cleanup();
        }
        clearTimeout(timeout);
    };
};
